<template>
  <v-container class="pa-0" fluid>
    <div class="pt-4">
      <v-card outlined>
        <v-card-title class="pt-2">
          <h3>{{ $t('Įregistruoti objektai pusmečiais') }}</h3></v-card-title
        >
        <v-card-text>
          <el-overlay-loading dashboard :loading="pageloading" />
          <v-row class="pt-1 pb-3">
            <v-col cols="12" md="6" lg="3">
              <el-autocomplete
                @change="updateBoard()"
                :items="formatedYears"
                direct
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Nuo"
                v-model="formData.from"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-autocomplete
                @change="updateBoard()"
                :items="formatedYears"
                direct
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Iki"
                v-model="formData.to"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <!-- <export-btn
                object="registered-objects-sem"
                :id="chartId"
              ></export-btn> -->
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="pt-1 pb-3">
            <v-col cols="12">
              <Bar
                :chart-options="chartOptions"
                :chart-data="chartData"
                :chart-id="chartId"
                :dataset-id-key="datasetIdKey"
                :plugins="plugins"
                :css-classes="cssClasses"
                :styles="styles"
                :width="width"
                :height="height"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const customLabels = {
  id: 'customLabels',
  afterDatasetsDraw: (chart, args, opts) => {
    const ctx = chart.ctx
    const datasets = chart.data.datasets

    datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex)
      if (!meta.hidden) {
        meta.data.forEach((element, index) => {
          const dataPoint = dataset.data[index] || ''
          const x = element.x
          const y = element.y

          ctx.fillStyle = 'black' // Customize label color
          ctx.font = '10px Arial' // Change font size to 10
          ctx.textAlign = 'center'
          ctx.fillText(dataPoint, x, y - 10) // Display dataPoint value above the bar
        })
      }
    })
  },
}

export default {
  name: 'RegisteredSemiannuallyForm',
  components: {
    Bar,
  },
  data() {
    return {
      pageloading: false,
      //
      formData: {},
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                return value.toString()
              },
            },
          },
        },
        plugins: {
          tooltip: {
            intersect: false,
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || ''
                if (label) {
                  label += ': '
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y.toString()
                }
                return label
              },
            },
          },
          customLabels: {
            display: true,
          },
        },
      },
      //
      chartId: 'registered-objects-sem-chart',
      datasetIdKey: 'label',
      width: 400,
      height: 200,
      cssClasses: '',
      styles: {},
      plugins: [customLabels],
    }
  },
  computed: {
    formatedYears() {
      let years = []
      let year = new Date().getFullYear()
      while (year >= 2010) {
        years.push(year.toString())
        year--
      }
      return years
    },
  },
  created() {
    this.$set(this.formData, 'from', new Date().getFullYear().toString())
    this.$set(this.formData, 'to', new Date().getFullYear().toString())

    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true

      this.$axios
        .post(`dashboard/annual`, this.formData)
        .then((res) => {
          this.chartData = {
            labels: res.data.labels,
            datasets: [
              {
                label: 'Pirmas pusmetis',
                backgroundColor: 'rgba(0, 76, 76, 1)',
                borderColor: 'rgba(0, 76, 76, 1)',
                data: res.data.data[0],
              },
              {
                label: 'Antras pusmetis',
                backgroundColor: 'rgba(255, 153, 102, 1)',
                borderColor: 'rgba(255, 153, 102, 1)',
                data: res.data.data[1],
              },
            ],
          }
          this.pageloading = false
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.pageloading = false
        })
    },
    updateBoard() {
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped></style>
